












































































import Component from "vue-class-component";
import TextMonthChangePicker from "@/components/common/TextMonthChangePicker.vue";
import { HeaderWidthItem } from "@/types";
import { billingListDetailHeaders } from "@/components/dashboard/billingListDetailHeaders";
import { Emit, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {
    TextMonthChangePicker
  }
})
export default class BillingList extends Vue {
  @Prop({ default: "" }) private yearmonth!: string;
  @Prop({ default: "対象年月" }) private label!: string;
  @Prop({ default: "" }) private hint!: string;

  @Prop({ default: () => [] }) private tableItems!: object[];

  @Emit("update:yearmonth") private updateYearmonth(value: string) {
    return value;
  }

  @Emit() private search() {
    return;
  }

  @Emit() private download() {
    return;
  }

  @Watch("tableItems") watchTableItems() {
    this.onresize();
  }

  //=================================================================
  // 請求一覧（詳細）
  //=================================================================
  //項目
  private headerItems: HeaderWidthItem[] = billingListDetailHeaders;

  //=================================================================
  // データテーブルのスタイル用
  //=================================================================
  private isTableScroll = true;

  //=================================================================
  // 対象年月
  //=================================================================
  private get Yearmonth() {
    return this.yearmonth;
  }
  private set Yearmonth(yearmonth: string) {
    this.updateYearmonth(yearmonth);
  }

  //=================================================================
  // マウント
  //=================================================================
  //画面表示で検索をかける
  mounted() {
    // リサイズイベント登録
    window.onresize = () => {
      this.onresize();
    };
  }

  beforeDestroy() {
    window.onresize = null;
  }

  //---------------------------------------------
  //リサイズイベント
  //---------------------------------------------
  private onresize() {
    // データテーブルのスタイル切り替え
    this.isTableScroll = true;
    const dataTable = document.getElementById(
      "data-table"
    ) as HTMLElement | null;
    if (dataTable) {
      const table = dataTable.children[0].children[0] as HTMLElement | null;
      if (table) {
        if (dataTable.offsetHeight >= table.offsetHeight) {
          // 成り行き
          const root = document.getElementById("root") as HTMLElement | null;
          if (dataTable && root) {
            const dr = dataTable.getBoundingClientRect();
            const rr = root.getBoundingClientRect();
            // console.log('rect', dr, rr)
            if (rr.bottom <= dr.bottom) {
              this.isTableScroll = true;
            } else {
              this.isTableScroll = false;
            }
          }
        } else {
          // スクロール
          this.isTableScroll = true;
        }
      }
    }
  }
}
